import { Card, Checkbox, Flex, SimpleTable, Typography } from "djuno-design";
import { useState } from "react";
import ExpandableCard from "../../components/ExpandableCard";
import { ComponentCard } from "../ComponentsOverviewPage";
import { copyableUrl } from "../../urls";

const { Title, Text } = Typography;

const BlogsOverviewPage = () => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Flex direction="col">
        <div className="flex flex-wrap gap-4">
          <ComponentCard to={copyableUrl}>
            <Title level={3}>{`copyable`}</Title>
          </ComponentCard>
        </div>
      </Flex>
    </div>
  );
};

export default BlogsOverviewPage;
